import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("修改")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("删除")

import { ref, Ref, reactive, onBeforeMount } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import { formatNumber, formatTime } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  'POST/banks/list': fetchList,
  // 新增银行
  'POST/banks': bankAddApi,
  // 修改银行
  'PATCH/banks': bankModifyApi,
  // 删除银行
  'DELETE/banks/{id}': delApi,
} = Api

const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)


const searchConfig = ref([
  {
    label: '银行',
    value: '',
    upKey: 'key',
    props: {clearable: true, placeholder: '请输入银行'},
  },
])

// 添加
const addConfig = ref([
  {
    label: '银行全称',
    value: '',
    upKey: 'fullName',
    rule: [{ required: true, message: '请输入银行全称', trigger: 'change' }],
    props: {clearable: true, placeholder: '请输入银行'},
  },
  {
    label: '银行简称',
    value: '',
    upKey: 'alias',
    rule: [{ required: true, message: '请输入银行简称', trigger: 'change' }],
    props: {clearable: true, placeholder: '请输入银行'},
  },
])
const addFg = ref<boolean>(false)
const addHandle = () => {
  MI_modifyForm({}, addConfig, addFg, async(params: any) => {
    await bankAddApi(params)
    ElMessage.success('新增成功')
    addFg.value = false
    fetchData(MI_params)
  })
}

// 修改
const modifyFg = ref<boolean>(false)
const modifyConfig = ref([
  {
    label: '银行全称',
    value: '',
    upKey: 'fullName',
    rule: [{ required: true, message: '请输入银行全称', trigger: 'change' }],
    props: {clearable: true, placeholder: '请输入银行'},
  },
  {
    label: '银行简称',
    value: '',
    upKey: 'alias',
    rule: [{ required: true, message: '请输入银行简称', trigger: 'change' }],
    props: {clearable: true, placeholder: '请输入银行'},
  },
])
const modifyHandle = (row: any) => {
  MI_modifyForm(row, modifyConfig, modifyFg, async(params: any) => {
    await bankModifyApi({...params, id: row.id})
    ElMessage.success('修改成功')
    modifyFg.value = false
    fetchData(MI_params)
  })
}

// 删除
const delHandle = (row: any) => {
  ElMessageBox.confirm(`请确认是否删除 ${row.fullName}?`,
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      MI_identify.value = true
      return delApi({id: row.id})
    }).then(() => {
      MI_identify.value = false
      fetchData(MI_params)
      ElMessage.success('成功')
    }).finally(() => {
      MI_identify.value = false
    })
}


return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "银行维护搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({ ref: "searchForm" }, {
          initSearch: true,
          title: true,
          searchConfig: searchConfig.value,
        }, { onSearchFn: _unref(fetchData) }), null, 16, ["onSearchFn"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_button, {
      class: "mt-10",
      type: "primary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (addHandle()))
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      data: _unref(MI_tableData),
      "max-height": _unref(MI_height) + 'px',
      style: {"width":"900px"},
      class: "mt-10"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "银行全称",
          prop: "fullName",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "银行简称",
          prop: "alias",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "创建时间",
          prop: "createdAt",
          "show-overflow-tooltip": "",
          formatter: _unref(formatTime)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, { label: "操作" }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_space, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_link, {
                  type: "primary",
                  onClick: ($event: any) => (modifyHandle(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_link, {
                  type: "danger",
                  onClick: ($event: any) => (delHandle(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: addFg.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((addFg).value = $event)),
      title: "新增银行"
    }, {
      default: _withCtx(() => [
        (addFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
        searchConfig: addConfig.value,
        submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: modifyFg.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((modifyFg).value = $event)),
      title: "修改银行"
    }, {
      default: _withCtx(() => [
        (modifyFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
        searchConfig: modifyConfig.value,
        submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})